import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  applyFieldTextSize,
  readFieldTextSize,
  writeFieldTextSize,
  type FieldTextSize,
} from '../lib/fieldTextSizeStorage'

type Props = {
  className?: string
}

/** Normal / Large text control for field-facing screens. */
export function FieldTextSizeToggle({ className = '' }: Props) {
  const { t } = useTranslation('settings')
  const [current, setCurrent] = React.useState<FieldTextSize>(() => readFieldTextSize())

  const select = (size: FieldTextSize) => {
    if (size === current) return
    writeFieldTextSize(size)
    applyFieldTextSize(size)
    setCurrent(size)
  }

  return (
    <div className={`space-y-2 ${className}`}>
      <p className="text-sm font-medium text-gray-700">{t('fieldTextSize.label')}</p>
      <div className="flex flex-wrap gap-2">
        {(['normal', 'large'] as FieldTextSize[]).map((size) => (
          <button
            key={size}
            type="button"
            onClick={() => select(size)}
            className={`min-h-[44px] px-4 rounded-xl border text-sm font-semibold transition-colors ${
              current === size
                ? 'bg-blue-50 border-blue-200 text-blue-700'
                : 'border-gray-200 text-gray-600 hover:bg-gray-50'
            }`}
          >
            {size === 'normal' ? t('fieldTextSize.normal') : t('fieldTextSize.large')}
          </button>
        ))}
      </div>
      <p className="text-xs text-gray-500">{t('fieldTextSize.hint')}</p>
    </div>
  )
}
